import { render, staticRenderFns } from "./item_quantity.vue?vue&type=template&id=23c1d187&"
import script from "./item_quantity.vue?vue&type=script&lang=js&"
export * from "./item_quantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports